/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountValueDialog extends SiteEntityDialog<AccountValueRow, any> {
        protected getFormKey() { return AccountValueForm.formKey; }
        protected getIdProperty() { return AccountValueRow.idProperty; }
        protected getLocalTextPrefix() { return AccountValueRow.localTextPrefix; }
        protected getNameProperty() { return AccountValueRow.nameProperty; }
        protected getService() { return AccountValueService.baseUrl; }

        protected form = new AccountValueForm(this.idPrefix);

    }
}